/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'document': {
    width: 16,
    height: 16,
    viewBox: '0 0 26 32',
    data: '<path pid="0" d="M18 0l8 8v22c0 .56-.2 1.04-.58 1.42-.34.34-.75.53-1.24.57L24 32H2c-.56 0-1.04-.2-1.42-.58A1.91 1.91 0 010 30.18V2C0 1.44.2.96.58.58.92.24 1.33.05 1.82 0H18zm-3 2H2v28h22V11h-9V2zm5 19a1 1 0 110 2H6a1 1 0 110-2h14zm0-5a1 1 0 110 2H6a1 1 0 110-2h14zM17.19 2H17v7h7v-.16L17.19 2z"/>'
  }
})
